import { render, staticRenderFns } from "./ConversationBox.vue?vue&type=template&id=44397a09&scoped=true&"
import script from "./ConversationBox.vue?vue&type=script&lang=js&"
export * from "./ConversationBox.vue?vue&type=script&lang=js&"
import style0 from "./ConversationBox.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ConversationBox.vue?vue&type=style&index=1&id=44397a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44397a09",
  null
  
)

export default component.exports